import { apiClient } from './api';
import { ApiResponse } from '@/types';

export interface ProfileApiResponse {
  id: string;
  handle: string;
  avatar: string | null;
  personal: {
    firstName: string;
    lastName: string;
    middleName: string;
    bio: string;
    dateOfBirth: string | null;
    gender: string;
  };
  socials: any[];
  location: {
    birthPlace: {
      country: string;
      city: string;
      postalCode: string;
    };
    residencePlace: {
      country: string;
      city: string;
      postalCode: string;
    };
  };
  metrics: {
    followers: number;
    following: number;
    coauthors: number;
  };
  preferences: {
    avatarVisibility: string;
    allowedUsers: string[];
    emailNotificationsEnabled?: boolean;
  };
  security: {
    email: string;
    password: string;
    hasSubscription: boolean;
  };
  wallet: {
    balance: number;
  };
  createdAt: string;
  updatedAt: string;
}

export interface ProfileUpdateRequest {
  handle?: string;
  email?: string;
  name?: string;
  avatar?: string;
  personal?: {
    firstName?: string;
    lastName?: string;
    middleName?: string;
    bio?: string;
    dateOfBirth?: string | null;
    gender?: string;
  };
  preferences?: {
    avatarVisibility?: string;
    emailNotificationsEnabled?: boolean;
  };
  location?: {
    birthPlace?: {
      country?: string;
      city?: string;
      postalCode?: string;
    };
    residencePlace?: {
      country?: string;
      city?: string;
      postalCode?: string;
    };
  };
  phone?: string;
  [key: string]: any;
}

export const profileApi = {
  async getProfile(): Promise<ApiResponse<ProfileApiResponse>> {
    const response = await apiClient.get<ProfileApiResponse>('/profile/');
    return response;
  },

  async updateProfile(
    data: ProfileUpdateRequest
  ): Promise<ApiResponse<ProfileApiResponse>> {
    const response = await apiClient.patch<ProfileApiResponse>(
      '/profile/',
      data
    );
    return response;
  },
};
